import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetRegistrations = tags => {
  const endpoint = `/current-term/registrations?include=user&filter[tags]=${tags}&limit=1000`
  const query = useApiQuery(
    ['registrations', tags],
    'schools',
    endpoint,
    {
      enabled: !!tags
    },
    { authenticated: true, version: 4 }
  )

  return {
    registrations: query.data ?? [],
    isLoadingRegistrations: query.isLoading,
    isFetchingRegistrations: query.isFetching,
    getRegistrations: query.refetch,
    errorRegistrations: query.isError ? query.error : null
  }
}
